import { exampleUser, User } from '../user/User';
import { exampleSupportCategory, SupportCategory } from './SupportCategory';

export enum SupportTicketStatus {
  Open = 1,
  PendingStaff = 2,
  PendingUser = 3,
  Closed = 4,
}

export enum SupportTicketUrgency {
  High = 1,
  Moderate = 2,
  Low = 3,
}

export interface SupportTicket {
  id: number;
  name: string;
  body: string;
  user: User;
  status: SupportTicketStatus;
  category: SupportCategory;
  createdAt: number;
  updatedAt: number;
}

export const exampleSupportTicket: SupportTicket = {
  id: 1,
  name: 'Help me',
  body: 'I need help with this problem',
  user: exampleUser,
  status: SupportTicketStatus.Open,
  category: exampleSupportCategory,
  createdAt: +new Date() / 1000,
  updatedAt: +new Date() / 1000,
};
